import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class PdfReportService {
  private apiUrl = '/pdfreports';
  private apiSpringUrl = '/spring/pdfreport';
  private apiCreateFormUrl = '/spring/createForm';

  constructor(private http: HttpService) { }

  get(reporttrnId: number): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}?reporttrnId=${reporttrnId}`;
    return this.http.get(url);
  }
    
  printReport(reportCd: string, reporttrnId: number): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiCreateFormUrl}/createfile/${reportCd}`;
    return this.http.post(url, {reporttrnId:reporttrnId});
  }

  postSpring(
    reportCd: string,
    updprogramCd: string,
    selectIdList ?: Set<string>
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/${reportCd}`;
    let jsonInput = {};
    if (selectIdList === undefined) {
       jsonInput = {
        updprogramCd: updprogramCd,
       };
    } else {
      jsonInput = {
        updprogramCd: updprogramCd,
        selectIdList: Array.from(selectIdList.values())
       };
    }
    return this.http.post(url, jsonInput);
  }

  post(
    ownerId: number,
    parameter1Tx: string,
    reportCd: string,
    excelFl: number,
    updprogramCd: string,
    selectList?: object[]
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/reportStart/${reportCd}`;
    let jsonInput = {};
    if (selectList === undefined) {
      jsonInput = {
        ownerId: ownerId,
        parameter1Tx: parameter1Tx,
        parameter2Tx: excelFl,
        parameter3Tx: '',
        updprogramCd: updprogramCd,
      };
    } else {
      jsonInput = {
        ownerId: ownerId,
        parameter1Tx: parameter1Tx,
        parameter2Tx: excelFl,
        parameter3Tx: '',
        updprogramCd: updprogramCd,
        selectIds: selectList
      };
    }
    return this.http.post(url, jsonInput);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/pdf-report/pdf-report.service.ts